import Vue from 'vue';
import LoaderComponent from '../components/GlobalLoader.vue';

const LoaderConstructor = Vue.extend(LoaderComponent);


class LoadingService {
    constructor(vuetify, i18n) {
        this.vuetify = vuetify;
        this.i18n = i18n;
        this.loaders = [];
    }

    show() {
        const loaderInstance = new LoaderConstructor({
            vuetify: this.vuetify,
            i18n: this.i18n
        });
        loaderInstance.$mount();
        document.body.appendChild(loaderInstance.$el);
        loaderInstance.show();
        this.loaders.push(loaderInstance);
        return loaderInstance;
    }

    hide(loaderInstance) {
        if (loaderInstance) {
            loaderInstance.hide();
            document.body.removeChild(loaderInstance.$el);
            this.loaders = this.loaders.filter(loader => loader !== loaderInstance);
        }
    }
}

export default {
    install(Vue, { vuetify, i18n }) {
        const loadingService = new LoadingService(vuetify, i18n);
        Vue.prototype.$localLoader = loadingService;
    }
};
